export default {
    FETCHED_WALLET: 'FETCHED_WALLET',
    FETCHED_MERCHANT_WALLET: 'FETCHED_MERCHANT_WALLET',
    FETCHED_WALLET_DETAILS: 'FETCHED_WALLET_DETAILS',
    RECEIPTFILE : 'RECEIPTFILE',
    ADDWALLETRES:'ADDWALLETRES'
}